// SettingToggle — shared toggle-switch row for settings screens: bold label,
// an always-visible description of what the setting does, and a pill/thumb
// switch on the right. Visual lifted from OmegaP0DispatchToggle.js's toggle
// (the most polished one already in the app) so every boolean setting looks
// and animates the same way instead of each screen hand-rolling its own.
export default function SettingToggle({
  label,
  description,
  checked,
  onChange,
  disabled = false,
  accent = "#4ade80",
  offColor = "var(--layer3)",
  size = "md", // "md" = 52x28 (most rows), "lg" = 60x32 (a couple of higher-emphasis toggles)
  testId,
  extra, // optional content rendered between the description and the switch (e.g. a transient "saved" badge)
}) {
  const dims = size === "lg"
    ? { w: 60, h: 32, thumb: 24, onLeft: 32, offLeft: 4, top: 4 }
    : { w: 52, h: 28, thumb: 22, onLeft: 27, offLeft: 3, top: 3 };

  return (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12 }}>
      <div>
        <div style={{ fontSize: 12, color: "var(--text)", fontWeight: 700 }}>{label}</div>
        {description && (
          <div style={{ fontSize: 11, color: "var(--muted)", marginTop: 2, lineHeight: 1.4 }}>{description}</div>
        )}
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 8, flexShrink: 0 }}>
        {extra}
        <button
          data-testid={testId}
          onClick={() => !disabled && onChange(!checked)}
          disabled={disabled}
          aria-label={label}
          aria-pressed={checked}
          style={{
            width: dims.w, height: dims.h, borderRadius: dims.h / 2, border: "none",
            cursor: disabled ? "default" : "pointer",
            background: checked ? accent : offColor,
            position: "relative", transition: "background 200ms",
            opacity: disabled ? 0.6 : 1,
          }}
        >
          <div style={{
            position: "absolute", top: dims.top, left: checked ? dims.onLeft : dims.offLeft,
            width: dims.thumb, height: dims.thumb, borderRadius: "50%",
            background: "#fff", transition: "left 200ms",
            boxShadow: "0 1px 4px rgba(0,0,0,0.25)",
          }} />
        </button>
      </div>
    </div>
  );
}
